import { Select, MenuItem, Grid, Stack, InputLabel } from '@mui/material';
import Input from './Input';
import CustomButton from './Button';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import PropTypes from 'prop-types';
import { getAuthRequest } from 'Api/api';
import { style } from 'constant/constants';
import { useState, useEffect } from 'react';
import ErrorForSelect from './ErrorForSelect';
import Loader from 'components/Loader';
import { preventChars } from 'utils/utils';

const InputFeilds = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    placeholder: 'Enter bracket name',
    maxLength: 149,
    required: true
  },

  {
    name: 'wholesalePrice',
    label: 'Wholesale Price ($)',
    type: 'number',
    placeholder: 'Enter bracket price',
    required: true
  },

  {
    name: 'contractorPrice',
    label: 'Contractor Price ($)',
    type: 'number',
    placeholder: 'Enter bracket price',
    required: true
  },

  {
    name: 'manufacturerPrice',
    label: 'Manufacturer Price ($)',
    type: 'number',
    placeholder: 'Enter bracket price',
    required: true
  },

  {
    name: 'retailerPrice',
    label: 'Retailer Price ($)',
    type: 'number',
    placeholder: 'Enter bracket price',
    required: true
  }
];

const BracketPriceForm = ({
  bracket,
  bracketInfo,
  buttonText,
  buttonClose,
  handleSubmit,
  handleCancelAction,
  handleBracketInfo,
  error,
  handleError
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [types, setTypes] = useState([]);
  const [material, setMaterial] = useState([]);

  const getTypes = async () => {
    try {
      setShowLoader(true);
      const types = await getAuthRequest('getBracketTypes');

      setTypes(types);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getMaterial = async () => {
    try {
      setShowLoader(true);
      const material = await getAuthRequest('getSnowBracketMaterials');

      setMaterial(material);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getTypes();
    getMaterial();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      {InputFeilds.map(({ name, type, placeholder, label, required }) => (
        <Stack key={name} direction="row" sx={{ marginTop: '3vh' }}>
          <Input
            type={type}
            inputProps={{
              step: 0.01
            }}
            placeholder={placeholder}
            onChange={handleBracketInfo}
            value={bracketInfo[name]}
            required={required}
            label={label}
            disabled={name == 'name'}
            onFocus={() => handleError(name, null)}
            onKeyDown={(event) => {
              name.includes('Price') && preventChars(event);
            }}
            name={name}
            error={error[name]}
          />
        </Stack>
      ))}
      {showLoader && <Loader open={showLoader} />}
      <Grid item xs={12} sx={{ ml: '5vh', mr: '5vh', marginTop: '3vh' }}>
        <>
          <InputLabel
            htmlFor="demo-simple-select-label"
            sx={{
              fontFamily: style.fontFamily,
              color: style.LIGHT.primary
            }}
            className="text-menu-color-green">
            Bracket Types<span className="text-red-600"> *</span>
          </InputLabel>
          <Select
            value={bracketInfo.type}
            size="small"
            sx={{ width: '100%', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
            name="type"
            onChange={handleBracketInfo}
            error={error.type}
            disabled={true}
            onFocus={() => handleError(bracketInfo.type, null)}>
            {types.length > 0 &&
              types.map(({ name, id }) => (
                <MenuItem value={id} key={id} sx={{ fontFamily: style.fontFamily }}>
                  {name}
                </MenuItem>
              ))}
          </Select>
          {error.type && <ErrorForSelect style={{ marginTop: 8 }}>{error.type}</ErrorForSelect>}

          <InputLabel
            htmlFor="demo-simple-select-label"
            sx={{
              fontFamily: style.fontFamily,
              color: style.LIGHT.primary,
              marginTop: '3vh'
            }}
            className="text-menu-color-green">
            Bracket Material<span className="text-red-600"> *</span>
          </InputLabel>
          <Select
            value={bracketInfo.material}
            size="small"
            sx={{ width: '100%', fontFamily: style.fontFamily, mt: 0, mb: -2 }}
            name="material"
            onChange={handleBracketInfo}
            error={error.material}
            disabled={true}
            onFocus={() => handleError(bracketInfo.material, null)}>
            {material.length > 0 &&
              material.map(({ name, id }) => (
                <MenuItem value={id} key={id} sx={{ fontFamily: style.fontFamily }}>
                  {name}
                </MenuItem>
              ))}
          </Select>
          {error.material && (
            <ErrorForSelect style={{ marginTop: 8 }}>{error.material}</ErrorForSelect>
          )}
        </>
      </Grid>

      <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ mr: '5vh' }}>
        {/* add more button will not show in case of edit */}
        {!bracket?.bracketId && (
          <CustomButton
            sx={{ ml: '15vh' }}
            type="submit"
            onClick={handleSubmit}
            endIcon={buttonText === 'Save' ? <SaveIcon /> : <AddIcon />}>
            {buttonText}
          </CustomButton>
        )}
        {buttonText !== 'Save' && (
          <CustomButton type="button" endIcon={<SaveIcon />} onClick={handleCancelAction}>
            {bracket?.bracketId ? 'Save' : buttonClose}
          </CustomButton>
        )}
      </Stack>
    </form>
  );
};

BracketPriceForm.propTypes = {
  bracketInfo: PropTypes.object,
  setBracketInfo: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClose: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleCancelAction: PropTypes.func,
  handleBracketInfo: PropTypes.func,
  handleError: PropTypes.func,
  types: PropTypes.array,
  material: PropTypes.array,
  bracket: PropTypes.object,
  error: PropTypes.object
};

export default BracketPriceForm;
